import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import './scss/style.scss';


const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)


import io from 'socket.io-client';
import { restApiUri } from './config';

const socket = io.connect(restApiUri);

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/login/Login'));
class App extends Component {

  /*componentDidMount() {
    window.onbeforeunload = function() {
      localStorage.clear()
    }
  }*/

  render() {
    return (
      <BrowserRouter>
          <React.Suspense fallback={loading}>
            <Switch>
              <Route path="/login" name="Se connecter" render={props => <Login {...props}/>} />
              <Route path="" exact={true} name="Accueil" render={props => <TheLayout socket={socket} {...props}/>} />
            </Switch>
          </React.Suspense>
     </BrowserRouter>
    )
  }
}

export default App;
